import React, {useContext, useEffect, useState, useCallback} from 'react';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';

import UsersList from '../UsersList';
import styles from './UsersPage.module.css';

import _firebaseContext from '../../../contexts/firebaseContext';
import _appContext from '../../../contexts/appContext';

export default function UsersPage() {
    const firebaseContext = useContext(_firebaseContext);
    const appContext = useContext(_appContext);

    let scrollDebounceTimer;
    const usersRoleType = 'users';
    const usersLimitToLoad = 20;
    const [isNextUsersListLoading, setIsNextUsersListLoading] = useState(false);
    const [isUserUpdateLoading, setIsUserUpdateLoading] = useState(false);
    const [searchRequest, setSearchRequest] = useState('');

    useEffect(() => {
        setIsUserUpdateLoading(firebaseContext.data.fetchingState.updateUser);
    }, [firebaseContext.data.fetchingState.updateUser]);

    const handleScroll = useCallback(() => {
        clearTimeout(scrollDebounceTimer);
        const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        if ((windowBottom >= (docHeight * 0.9)) && firebaseContext.data.shouldLoadNextUsers) {
            if (!searchRequest) {
                scrollDebounceTimer = setTimeout(() => {
                    firebaseContext.getNextUsersList(usersLimitToLoad, setIsNextUsersListLoading);
                }, 300);
            } else {
                scrollDebounceTimer = setTimeout(() => {
                    firebaseContext.searchNextUsers(usersLimitToLoad, searchRequest, setIsNextUsersListLoading);
                }, 300);
            }
        }
    }, [firebaseContext.data[usersRoleType], firebaseContext.data.shouldLoadNextUsers, searchRequest]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);

    useEffect(() => {
        if (firebaseContext.data.fetchingState[usersRoleType]) {
            appContext.startLoading();
        } else {
            appContext.endLoading();
        }
    })

    useEffect(() => {
        firebaseContext.getInitialUsersList(usersLimitToLoad);
    }, []);

    const searchRequestHandler = searchValue => {
        setSearchRequest(searchValue);
    }

    return (
        <>
            <Typography
                variant='h4'
                component='h1'
                className={styles.page__title}
            >
                Страница управления пользователями
            </Typography>
            <Divider/>
            <UsersList
                type={usersRoleType}
                searchRequest={searchRequest}
                searchRequestHandler={searchRequestHandler}
                usersLimitToLoad={usersLimitToLoad}
            />
            {
                isNextUsersListLoading &&
                <CircularProgress color={'primary'} className={styles.page__preloader}/>
            }
            {
                isUserUpdateLoading &&
                <Backdrop style={{zIndex: 10000}} open={true}>
                    <CircularProgress style={{color: '#FFF'}}/>
                </Backdrop>
            }
        </>
    )
}
